const { Box } = require("@mui/material");
const { default: styled } = require("@emotion/styled");

const FlexBewteen = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export default FlexBewteen;
